import React, { useState } from "react";
import { AGridColDef } from "../../../common/data-grid/ADataGridColDef";
import { ReactComponent as EyeIcon } from "../../../../../../assets/img/svg/eye.svg";
import { ReactComponent as InfoIcon } from "../../../../../../assets/img/svg/fi_info.svg";
import { Tooltip } from "@mui/material";
import ADataGrid from "../../../common/data-grid/ADataGrid";
import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";
import {
  gridStyles,
  gridComponents,
} from "../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import NoRowOverlay from "../../../masters/holidayMaster/NoRowOverlay";
import ALoader from "../../../common/a-loader";
import ConfirmRejectionDialog from "./ConfirmRejectionDialog";
import AButton from "../../../common/form-fields-mui/AButton";
import CustomChip from "../../../common/customChip/CustomChip";
import { RemarkTooltipTitle, statusStyles } from "./utils";
import CustomTooltip from "../../../common/customTooltip/CustomTooltip";
import { formattedPrice } from "../../collectPayment/utils";
import { getFormatedDateTime } from "../../studentCharges/studentChargesDetails/concessionDetails/discretionary";
import PaymentModeChangeAlertDialog from "../../../masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/modifyPayment/PaymentModeChangeAlertDialog";

const ApprovalRequestsList = ({
  approvalRequestsInfo,
  pageChangeHandler,
  updateStatus,
  allActiveBu = [],
  loading,
  isApprovePermission,
}) => {
  const [updateStatusInfo, setUpdateStatusInfo] = useState(null);

  const [paymentModeChangeDialogInfo , setPaymentModeChangeDialogInfo] = useState({isOpen : false , rowData : {}})

  const { data, currentPage, totalRecords } = approvalRequestsInfo;

  const actionButtonClickHandler = (params, status) => {
    const {oldPaymentMode , oldReferenceNumber, pserpReceiptId} = params?.row
    setPaymentModeChangeDialogInfo({
      isApiCall : true,
      status,
      rowData : {
        ...params?.row,
        paymentMode : oldPaymentMode,
        paymentTransactionId : oldReferenceNumber,
        receiptId : pserpReceiptId
      }
    })
  }

  const paymodeChangeDialogConfirmHandler = () => {
    const {status , rowData} = paymentModeChangeDialogInfo;
    const {id , acknowledgementId} = rowData;

    return status === "Approved"
    ? () => updateStatus({id , status , acknowledgementId})
    : () => setUpdateStatusInfo({id , status , acknowledgementId})

  }

  const columns = [
    new AGridColDef("pserpReceiptId", "PSERP receipt ID", false)
      .setMinWidth(170)
      .setFlex(1)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("businessAreaId", "Branch", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .renderCellComponent((params) => {
        const bu = allActiveBu?.find((bu) => bu?.value === params?.value);

        return (
          <>
            <span>{bu?.label}</span>
            <Tooltip title={bu?.businessAreaDesc}>
              <EyeIcon className="ml-2" />
            </Tooltip>
          </>
        );
      }),

    new AGridColDef("psid", "PSID", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("cashierId", "Cashier ID", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("applicationId", "Application ID", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("oldPaymentMode", "Old Pay", false)
      .setMinWidth(80)
      .setFlex(0.6)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("newPaymentMode", "New Pay", false)
      .setMinWidth(80)
      .setFlex(0.6)
      .editable(false)
      .setValueGetter((params) => params.value),

    new AGridColDef("paidAmount", "Amount", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(false)
      .renderCellComponent((params) => <b>{formattedPrice(params.value)}</b>),

    new AGridColDef("status", "Status", false)
      .setMinWidth(190)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        const status = params?.value;
        const remark = params?.row?.remark;
        const updatedOn = getFormatedDateTime(params?.row?.updatedOn)
        return (
          <>
            <CustomChip
              className="text-wrap mt-1 w-100 text-center"
              {...statusStyles[status]}
            />
            <CustomTooltip title={<RemarkTooltipTitle remark={remark} updatedOn={updatedOn} />}>
              <span>
                <InfoIcon className="ml-1" />
              </span>
            </CustomTooltip>
          </>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(200)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        const status = params?.row?.status;
        const disableActions = status !== "Pending";
        const acknowledgementId = params?.row?.acknowledgementId;
        return (
          isActiveBusinessArea({ buId: params.row.businessAreaId }) &&
          isApprovePermission && (
            <div>
              <AButton
                variant="danger_filled"
                size="xs"
                className="no-ml-btn"
                disabled={disableActions}
                onClick={() =>{
                  // setUpdateStatusInfo({
                  //   id: params?.row?.id,
                  //   status: "Rejected",
                  //   acknowledgementId,
                  // });
                   actionButtonClickHandler(params, "Rejected")
                }
                }
              >
                Reject
              </AButton>

              <AButton
                variant="primary_filled"
                size="xs"
                disabled={disableActions}
                onClick={() =>{
                  // updateStatus({
                  //   id: params?.row?.id,
                  //   status: "Approved",
                  //   acknowledgementId,
                  // })
                  actionButtonClickHandler(params, "Approved")
                }
              }
              >
                Approve
              </AButton>
            </div>
          )
        );
      }),
  ];

  return (
    <>
      {(loading || !allActiveBu?.length) && <ALoader position="fixed" />}
      <ADataGrid
        removeWrapperContainer
        // rowModesModel={rowModesModel}
        rows={data || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        nextButtonHandler={pageChangeHandler}
        currentPage={currentPage}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loading ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        autoHeight
        // pinLastColumn
      />

      <ConfirmRejectionDialog
        updateStatusInfo={updateStatusInfo}
        setUpdateStatusInfo={setUpdateStatusInfo}
        updateStatus={updateStatus}
      />

      <PaymentModeChangeAlertDialog
      dialogInfo={paymentModeChangeDialogInfo}
      setDialogInfo={setPaymentModeChangeDialogInfo}
      confirmHandler={paymodeChangeDialogConfirmHandler()}
      key={paymentModeChangeDialogInfo?.isOpen}
      />
    </>
  );
};

export default ApprovalRequestsList;
